import { Button, Card } from '@cmsgov/ds-medicare-gov'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'

export interface MAClaimsProps {
  eventAction: () => void
}

export const MAClaims: FC<MAClaimsProps> = ({ eventAction }) => {
  const { t } = useTranslation('claimsSearch')

  return (
    <section className='ds-l-container ds-u-margin-top--3'>
      <div className='ds-l-row'>
        <Card className='ds-u-align-items--start ds-u-display--flex ds-u-flex-direction--column ds-u-justify-content--between ds-u-padding--3 my-u-height-full'>
          <div>
            <p>{t('medicareAdvantageEnrollmentMessage')}</p>
            <p>{t('medicareAdvantageSearchMessage')}</p>
          </div>
        </Card>
      </div>
      <div className='ds-l-row ds-u-margin-top--3'>
        <div className='ds-l-col--12'>
          <div className='ds-l-row ds-u-justify-content--center'>
            <Button
            data-testid='search-claims-button'
            className='my-c-ma-search-button'
            onClick={() => eventAction()}>
              {t('medicareAdvantageSearchClaimsButton')}
            </Button>
          </div>
        </div>
      </div>
    </section>
  )
}
